import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref } from 'vue';
import { useRouter } from 'vue-router';
import type Client from '@/models/client';
import ClientsMenu from '@/components/layout/ClientsMenu.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'SideNav',
  props: {
    clientMenuItems: {},
    filteredClients: {}
  },
  setup(__props: any) {

const router = useRouter();
const menu = ref(false);
const searchQuery = ref('');

const colors = {
  PRIMARY: '#714FE3',
  ACCENT: '#F29B00',
  NEUTRAL: '#FFFFFF'
};

const props = __props;

const selectClient = (client: Client) => {
  menu.value = false;
  router.push(`/client/${client.id}`);

  setTimeout(() => {
    searchQuery.value = '';
  }, 300);
};

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_navigation_drawer = _resolveComponent("v-navigation-drawer")!

  return (_openBlock(), _createBlock(_component_v_navigation_drawer, {
    app: "",
    color: colors.NEUTRAL
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_list, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_list_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_btn, {
                block: "",
                color: colors.PRIMARY,
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ name: 'addClient' })))
              }, {
                default: _withCtx(() => _cache[4] || (_cache[4] = [
                  _createTextVNode(" Add Client ")
                ])),
                _: 1
              }, 8, ["color"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_list_item, null, {
            default: _withCtx(() => [
              _createVNode(ClientsMenu, {
                clients: _ctx.clientMenuItems,
                "filtered-clients": _ctx.filteredClients,
                menu: menu.value,
                "search-query": searchQuery.value,
                "onUpdate:menu": _cache[1] || (_cache[1] = ($event: any) => (menu.value = $event)),
                "onUpdate:searchQuery": _cache[2] || (_cache[2] = ($event: any) => (searchQuery.value = $event)),
                onSelectClient: selectClient
              }, null, 8, ["clients", "filtered-clients", "menu", "search-query"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_list_item, { class: "activity-history-button" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_btn, {
                block: "",
                color: colors.PRIMARY,
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$router.push({ name: 'activityHistory' })))
              }, {
                default: _withCtx(() => _cache[5] || (_cache[5] = [
                  _createTextVNode(" Activity History ")
                ])),
                _: 1
              }, 8, ["color"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["color"]))
}
}

})